import { DSNoteDisplay } from "@components/design-system/organisms";
import {
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { usePlainNoteEditor } from "@hooks";
import React, { useState } from "react";

import {
  getObjectiveFieldsString,
  getObjectiveSectionText,
} from "../../common/clinical/utils";
import DentalChart from "../../notes/edit/form/DentalChart";

export default function NotesExpandableSection({ data }) {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const plainText = usePlainNoteEditor();

  const isFreeform = data?.shouldUseCustomForm;

  const noteDisplayData = isFreeform
    ? { content: data?.customFormFields?.[0]?.textValue }
    : {
        subjective: data?.subjective,
        objective: data?.shouldUseGenericObjective
          ? getObjectiveSectionText(data)
          : getObjectiveFieldsString(data),
        assessment: data?.assessment,
        plan: data?.plan,
        additionalNotes: data?.additionalNotes,
      };

  const dentalChartExtra =
    isFreeform &&
    (data?.jobType === "dental_record" ||
      !!data?.dentalChartData ||
      (data?.jobType === "template" &&
        data?.autoTemplates?.dentalChart === true)) ? (
      <div className="md:w-[300px]">
        <DentalChart
          record={
            data?.autoTemplates?.dentalChart || data?.dentalChartData
              ? undefined
              : data?.customFormFields?.[0]?.textValue
          }
          dentalChartData={
            data?.autoTemplates?.dentalChart || data?.dentalChartData
              ? (data?.dentalChartData ?? null)
              : null
          }
          status={
            data?.autoTemplates?.dentalChart || data?.dentalChartData
              ? (data?.dentalChartStatus ?? "UP_TO_DATE")
              : undefined
          }
        />
      </div>
    ) : undefined;

  return (
    <div className="relative">
      <div
        style={{ height: isCollapsed ? "110px" : "auto" }}
        className={isCollapsed ? "py-2 overflow-hidden" : "py-2"}
      >
        <DSNoteDisplay
          data={noteDisplayData}
          variant={isFreeform ? "freeform" : "soap"}
          size="compact"
          extra={dentalChartExtra}
          plainText={plainText}
          dataTestId="inbox-note-display"
        />
      </div>
      <div
        onClick={() => setIsCollapsed(!isCollapsed)}
        title="Expand/collapse note"
        className={
          isCollapsed
            ? "w-full rounded-lg absolute z-10 top-16 pt-5 bg-linear-to-t from-[var(--surface-secondary)] via-[var(--surface-secondary)]"
            : "w-full rounded-lg pt-5"
        }
      >
        <div className="h-8 w-full hover:bg-brand-subtle rounded-full mx-auto flex items-center justify-center text-secondary transition-colors cursor-pointer">
          <FontAwesomeIcon
            icon={isCollapsed ? faChevronDown : faChevronUp}
          />
        </div>
      </div>
    </div>
  );
}
